import React, { Component } from 'react';
import { Link } from "react-router-dom";
import { graphql } from 'react-apollo';
import Spinner from '../../spinner/spinner';
import moment from 'moment-timezone';
import { Table, Button } from 'antd';
import { getChurches } from './queries/getChurches';
import { valuesComparator } from "../../../utilities/comparators";
import './churchList.css';

const REVIVAL_FINISH_PHASE = 3;

class ChurchList extends Component {
  get dataSource() {
    return (
      this.props.data.churches.map((church, index) => {
        return {
          id: church.id,
          key: index + 1,
          code: church.code,
          name: church.name,
          dates: this.datesList(church.revival, church.timezone),
          address: church.address,
          contactPerson: church.contactPerson,
          evangelistName: church.evangelist.name
        };
      })
    );
  }

  get columns() {
    return (
      [
        {
          title: '#',
          dataIndex: 'key',
        }, {
          title: 'Church code',
          dataIndex: 'code',
          sorter: (firstChurch, secondChurch) => {
            return valuesComparator(firstChurch.code, secondChurch.code);
          }
        }, {
          title: 'Church name',
          dataIndex: 'name',
          sorter: (firstChurch, secondChurch) => {
            return valuesComparator(firstChurch.name, secondChurch.name);
          }
        }, {
          title: 'Event dates',
          dataIndex: 'dates'
        }, {
          title: 'Address',
          dataIndex: 'address'
        }, {
          title: 'Contact person',
          dataIndex: 'contactPerson'
        }, {
          title: 'Evangelist',
          dataIndex: 'evangelistName'
        }, {
          title: 'Actions',
          dataIndex: '',
          key: 'x',
        render: (_value, church) => <Link to={`${this.props.match.url}/edit/${church.id}`}>Edit</Link>
        }
      ]
    );
  }

  datesList(revival, timezone) {
    if (revival.phase === REVIVAL_FINISH_PHASE) {
      if (revival.title === "NON_EVENT_MODE") {
        return (
          <div>
            <p>Non event mode</p>
          </div>
        );
      } else {
        return (
          <div>
            <p>Last event ({revival.title}) finished on {this.formattedDate(revival.endDate, timezone)}</p>
          </div>
        );
      }
    } else {
      return (
        <div>
          <p>{revival.title} Prep start - {this.formattedDate(revival.preparationStartDate, timezone)}</p>
          <p>{revival.title} start - {this.formattedDate(revival.startDate, timezone)}</p>
          <p>{revival.title} end - {this.formattedDate(revival.endDate, timezone)}</p>
        </div>
      );
    }
  }

  formattedDate(date, timezone) {
    return moment.unix(date).tz(timezone).format('D MMMM YYYY');
  }

  render() {
    if (this.props.data.loading) {
      return <Spinner />;
    } else {
      return (
        <div>
          <div className="m-24">
            <div className="church-list__controls align-right">
              <Link to={`${this.props.match.url}/new`}>
                <Button type="primary">Create new church profile</Button>
              </Link>
            </div>
            <Table className="groups-page__table" bordered columns={this.columns} dataSource={this.dataSource} />
          </div>
        </div>
      );
    }
  }
}

export default graphql(getChurches,
  {
    options: {
      fetchPolicy: 'network-only',
      notifyOnNetworkStatusChange: true //e.vasilevsky TODO: make it default after updating react-apollo to the latest version
    }
  })(ChurchList);



// WEBPACK FOOTER //
// ./src/components/pages/churches/churchList.js